import { passkeyClient } from '@better-auth/passkey/client';
import { vars } from '@repo/config';
import { adminClient, multiSessionClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const authClientInstance = createAuthClient({
  baseURL: vars.url.identityUrl,
  fetchOptions: {
    headers: { 'x-client-info': JSON.stringify({ platform: 'web' }) },
  },
  plugins: [adminClient(), passkeyClient(), multiSessionClient()],
});

type AuthClientType = typeof authClientInstance;

export const authClient: AuthClientType = authClientInstance;
export const signIn: AuthClientType['signIn'] = authClient.signIn;
export const signOut: AuthClientType['signOut'] = authClient.signOut;
export const useSession: AuthClientType['useSession'] = authClient.useSession;
export const getSession: AuthClientType['getSession'] = authClient.getSession;
export const passkey: AuthClientType['passkey'] = authClient.passkey;

export const signInWithGoogle = (): ReturnType<typeof signIn.social> =>
  signIn.social({
    provider: 'google',
    callbackURL: `${vars.url.webUrl}/my`,
  });

export const signInWithApple = (): ReturnType<typeof signIn.social> =>
  signIn.social({
    provider: 'apple',
    callbackURL: `${vars.url.webUrl}/my`,
  });

export const signInWithGoogleForLinking = (callbackURL: string): ReturnType<typeof signIn.social> =>
  signIn.social({ provider: 'google', callbackURL });

export const signInWithAppleForLinking = (callbackURL: string): ReturnType<typeof signIn.social> =>
  signIn.social({ provider: 'apple', callbackURL });

export async function completeSignup(): Promise<boolean> {
  const result = (await authClient.$fetch(`${vars.url.identityUrl}/signup/complete`, {
    method: 'POST',
  })) as { error?: { status?: number } | null };
  return !result?.error;
}
